import charming from 'charming'

const SELECTORS = {
  itemWords: '.charming-words',
  itemLetters: '.charming-letters'
}


export default class Charmings {
  constructor () {
    this.itemWords   = Array.from( RM.Select.el(SELECTORS.itemWords) );
    this.itemLetters = Array.from( RM.Select.el(SELECTORS.itemLetters) );
    RM.BM(this, ['onAppInit', 'onAppLoaded', 'onAppLoadedEnded', 'onAppResize']);

    if (this.itemWords.length || this.itemLetters.length) {
      this.init();
    }
  }

  init () {
    this.itemWords.forEach( item => charming(item, {
      split: function (string) {
        return string.split(/(\s+)/)
      },
      setClassName: function (index) {
        return `word-${index}`
      }
    }) );
    this.itemLetters.forEach( item => charming(item) );
  }

  onAppInit() {
  }

  onAppLoaded() {
  }

  onAppLoadedEnded() {
  }

  onAppResize() {
  }
}
